var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideNavNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18336 18L8.58336 18.6857C10.3834 21.7714 13.9834 21.7714 15.7834 18.6857L16.1834 18M4.36619 15.5496L4.46954 15.7627C5.13331 17.1311 6.52054 18 8.04144 18H16.2623C17.5656 18 18.7785 17.3342 19.4783 16.2347C20.4661 14.6826 20.2045 12.6465 18.8564 11.3945L18.8125 11.3538C17.8972 10.5038 17.4466 9.26543 17.6015 8.02598L17.6662 7.50905C18.0318 4.58379 15.7509 2 12.8029 2H11.0999C8.15552 2 5.87737 4.58064 6.24258 7.50234L6.32194 8.13719C6.46808 9.30631 6.04102 10.4741 5.17514 11.2731C3.99242 12.3645 3.66383 14.1016 4.36619 15.5496Z",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideNavNotificationIcon);
export default __webpack_public_path__ + "static/media/SideNavNotificationIcon.369cf4d0ee4089abd11c6d6b4f8960cf.svg";
export { ForwardRef as ReactComponent };